module.exports = __webpack_public_path__ + "static/media/dfci_small.79af4f41.png";